import React, { Component, Fragment } from 'react';
import { Row, Col } from 'react-bootstrap';
import moment from 'moment';
import Auth from '../../Auth/Auth';
import IsLoadingBar from '../isLoading';

import './D365CRM.scss';
import './QuickView.scss';

const auth = new Auth();

export class TFSDetails extends Component {
    render(){
        return (
            <div>
                <Row>
                    <Col lg={{ span : 3}}>
                        <div className="D365-content-container case-details">                        
                            <p><strong>TFS Number : </strong><a href={`https://dev.azure.com/Ceridian/SharpTop/_workitems/edit/${this.props.TFSDetails.TFSNumber}`} target="_blank" rel="noopener noreferrer" >{this.props.TFSDetails.TFSNumber}</a></p>
                            <p><strong>Type : </strong>{this.props.TFSDetails.BugType}</p>
                            <p><strong>Created Date : </strong>{moment(this.props.TFSDetails.CreatedDate).format("YYYY-MM-DD")}</p>
                            <p><strong>Changed Date : </strong>{moment(this.props.TFSDetails.ChangedDate).format("YYYY-MM-DD")}</p>
                            <p><strong>State : </strong>{this.props.TFSDetails.State}</p>
                            <p><strong>Reason : </strong>{this.props.TFSDetails.Reason}</p>
                            <p><strong>Support Rank : </strong>{this.props.TFSDetails.SupportRank}</p>
                            <p><strong>Estimated Release : </strong>{this.props.TFSDetails.estimatedrelease}</p>
                            <p><strong>Node Name : </strong>{this.props.TFSDetails.NodeName}</p>
                        </div>
                    </Col>
                    <Col lg={{ span : 9}}>
                        <div className="D365-content-container">
                            <h6 className="m-0">{this.props.TFSDetails.Title}</h6>
                            <div className="mb-2 d365-subtitles">
                            </div>                                
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }    
}

export default class TFS extends Component {
    constructor(props){
        super(props);

        this.state = {
            TFSNumber : this.props.TFSNumber,
            TFS: [],
            isLoading: true
        };
    }

    componentDidMount(){
        let data = this.props.caseDetails;
        if(data !== undefined){ 
            try{
                if(data.caseActivities[0].ReproSteps === null || data.caseActivities[0].ReproSteps === ""){
                    data.caseActivities[0].ReproSteps = 'No Repro Data found for this TFS - you can click the TFS Number above to go directly to the ticket';
                }
                let TFSdata = {
                    BugType: data.caseDetails[0].BugType,
                    CreatedDate: data.caseDetails[0].CreatedDate,
                    ChangedDate: data.caseDetails[0].ChangedDate,
                    State: data.caseDetails[0].State,
                    Reason: data.caseDetails[0].Reason,
                    SupportRank: data.caseDetails[0].SupportRank,
                    estimatedrelease: data.caseDetails[0].estimatedrelease,
                    NodeName: data.caseDetails[0].NodeName,
                    Title: data.caseDetails[0].Title,
                    ReproSteps: data.caseActivities[0].ReproSteps,
                    TFSNumber: data.caseDetails[0].TFSNumber
                };

                this.setState({
                    TFS : TFSdata,
                    isLoading: false
                });
            } catch {
                console.log('something went wrong');
            }                         
        } else {
            this.getTFS();
        }
    }



    componentDidUpdate(prevProps){
        if(prevProps.TFSNumber !== this.props.TFSNumber){
            this.setState({
                TFSNumber : this.props.TFSNumber
            })
            this.getTFS();
        }
    }

    async getTFS(){
        let accessToken = await auth.getToken();

        this.setState({
            isLoading : true,
            TFS: []
        });

        fetch('/api/getTFSItemsByNumber', {
            method : "GET",
            headers : {
                Authorization : "Bearer " + accessToken,
                withCredentials : true,
                crossDomain: true,
                TFSNumber: this.state.TFSNumber
            }           
        }).then(response => {
            if(response.status !== 200)
            {   
                let payload = [{
                    status : response.status,
                    rawmsg : response.statusText,
                    cleanmsg : response.status + " was thrown with the message of " + response.statusText + " on " + response.url,
                    location: response.url,
                    timestamp : Date.now(),
                }];
                throw {
                    payload: payload,
                    error: new Error()
                  };
            }
            return response.json();
        }).then(data => {
            if(Array.isArray(data[0]) && data[0].length){
                data = data[0]
                this.setState({
                    TFS : data[0],
                    isLoading: false
                });
            } else {
                let emptyTFS = {
                    ReproSteps : 'We were unable to find this TFS. We have been notified and will look into this'
                };
                this.setState({
                    TFS : emptyTFS,
                    isLoading: false
                });
            }     
        }).catch((error) => {
            window.apiError(error);
            this.setState({
                isLoading: false
            });
        });
    }

    render(){
        return (
            <div id="D365CRM" className="Quickview-details">
                {!this.state.isLoading ? 
                    <Fragment>                    
                        <TFSDetails TFSDetails={this.state.TFS} />

                        <Row >         
                             {(this.state.TFS.ReproSteps !== null && this.state.TFS.ReproSteps !== "") ?
                                <p className="quickview-info" dangerouslySetInnerHTML={{ __html : this.state.TFS.ReproSteps}}></p>
                                : 
                                <div className="quickview-info">
                                    <p>No Repro Data found for this TFS - you can click the TFS Number above to go directly to the ticket</p>
                                </div>
                               
                            }                  

                        </Row>  
                    </Fragment>
                :
                <IsLoadingBar />
                }
            </div>    
       );
    }
}

